import React from 'react';
import { useScrollSync, type HoverFeature } from './ScrollSyncProvider';
import { REPORT } from '../print/PrintAtoms';

interface HoverLinkProps {
  feature: HoverFeature;
  children: React.ReactNode;
  style?: React.CSSProperties;
}

export const HoverLink: React.FC<HoverLinkProps> = ({ feature, children, style }) => {
  const { hoverFeature, setHoverFeature } = useScrollSync();

  const isActive = hoverFeature != null && feature != null
    && hoverFeature.type === feature.type
    && (feature.type !== 'pipeline' || (hoverFeature as any).name === (feature as any).name);

  return (
    <span
      onMouseEnter={() => setHoverFeature(feature)}
      onMouseLeave={() => setHoverFeature(null)}
      style={{
        cursor: 'pointer',
        borderBottom: `1px dashed ${isActive ? REPORT.accent : 'transparent'}`,
        transition: 'border-color 0.15s, background 0.15s',
        background: isActive ? `${REPORT.accent}10` : 'transparent',
        borderRadius: '2px',
        padding: '0 1px',
        ...style,
      }}
    >
      {children}
    </span>
  );
};
